<template>
  <div>
    <Topbar title="Univers" backButton />
    <section v-if="universe" class="Section">
      <div class="Universe__header" :style="headerBackground">
        <h4 class="Universe__title">{{ universe.name }}</h4>
        <h5 class="Universe__subtitle" v-if="universe.subname">{{ universe.subname }}</h5>
      </div>
      <ul class="ProductList">
        <router-link :to="{ name: 'UniverseProduct', params: { universe_id: universe.id, id: product.id }}" v-for="product in universe.products" :key="product.id">
          <ProductCard v-bind="product" :universe="universe" />
        </router-link>
      </ul>
    </section>
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard";

import universeService from "../services/universe";

export default {
  data() {
    return {
      universe: null
    };
  },
  computed: {
    headerBackground() {
      return `background: grey url(${this.universe.picture.large}) center / cover;`;
    }
  },
  created() {
    universeService.get(this.$route.params.id)
      .then(({ data: universe }) => this.universe = universe);
  },
  components: { ProductCard }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.Universe {
  &__header {
    height: 12em;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    margin-bottom: $global-margin;
    color: #fff;
  }

  &__title,
  &__subtitle {
    text-align: center;
    color: inherit;
    font-weight: 900;
    text-transform: uppercase;
    padding: 0 2em;
    margin: 0;
  }

  &__subtitle {
    margin-top: $global-margin;
    max-width: 42em;
  }
}

@media (min-width: 900px) {
  .Universe__title {
    font-size: 1.875rem;
  }
}
</style>
